export default function Header() {
  return (
    <header className="bg-white shadow-sm p-3 mb-3 sticky-top">
      <div className="container d-flex justify-content-center align-items-center">
        <a href="https://dwightvillagemotel.com" target="_blank" rel="noopener noreferrer">
          <img
            src="/motel-logo.png"
            alt="Dwight Village Motel Logo"
            className="img-fluid"
            style={{ maxHeight: '50px' }}
          />
        </a>
      </div>
    </header>
  );
}
